module.exports = __webpack_public_path__ + "img/12.d2f2e908.png";